export default __webpack_public_path__ + "static/media/hipDude.0896034f.png";